import * as React from 'react';

import { connect } from 'react-redux';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import Cleave from 'cleave.js/react';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';


class Liquidacion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            didEdit: false
        };
        this.diasCorteInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.diasCorteInputRef.current && this.diasCorteInputRef.current.element) {
            this.diasCorteInputRef.current.element.focus();
        }
    }

    myChangeHandler = (event) => {
        this.setState({
            didEdit: true
        })

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    render() {
        let { seller } = this.props;

        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">


                <div className="row">

                    <div className="form-group col-lg-6">
                        <label> Días de corte </label>
                        <Cleave
                            className="form-control"
                            name="diasCorte"
                            value={seller.diasCorte || ""}
                            options={{ blocks: [2], numericOnly: true }}
                            onChange={this.myChangeHandler}
                            ref={this.diasCorteInputRef}
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label> Días de pago </label>
                        <Cleave className="form-control" name="diasPlazoPago" value={seller.diasPlazoPago || ""}
                            options={{ blocks: [2], numericOnly: true }}
                            onChange={this.myChangeHandler} />
                    </div>

                </div>


            </div>
        );
    }

}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    tipoUsuario: state.general.tipoUsuario,
});
export default connect(mapStateToProps, { fetchSeller, editSeller })(Liquidacion);